import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manifesting_ds_get_warehouse_addressService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouseId: number }): 
  Promise<{ result: { WarehouseId?: number, ContactId?: number, Warehouse?: { Id?: number, Name?: string, Notes?: string }, Contact?: { FirstName?: string, PrimaryEmail?: string, PrimaryTelephone?: string, ReferenceCode?: string, Address?: { City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manifesting/datasources/ds_get_warehouse_address/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { warehouseId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { WarehouseId?: number, ContactId?: number, Warehouse?: { Id?: number, Name?: string, Notes?: string }, Contact?: { FirstName?: string, PrimaryEmail?: string, PrimaryTelephone?: string, ReferenceCode?: string, Address?: { City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string } } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manifesting/datasources/ds_get_warehouse_address/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouseId: number, $keys: { WarehouseId?: number, ContactId?: number }[] }): 
  Promise<{ result: { WarehouseId?: number, ContactId?: number, Warehouse?: { Id?: number, Name?: string, Notes?: string }, Contact?: { FirstName?: string, PrimaryEmail?: string, PrimaryTelephone?: string, ReferenceCode?: string, Address?: { City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manifesting/datasources/ds_get_warehouse_address/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouseId: number    }) {
        if(isNil(inParams.warehouseId)) {
          return true; 
        }
      return false;
    }
}
